import { Attribute } from '../../../lib/attributes';
import { TagAttribute } from '../../../lib/tag';
import { RegisterWidget, Widget } from '../../../lib/widget';
import type { TagDefinition } from "../../../lib/tag";
import template from './pumpbank.html';
import { ColorInput } from '../../../../views/attributeeditorview';
import PumpBankWidget from '../../../../pumpbank'

//TODO:
// When we get all the necessary sub widgets (Pump header, pump curves, settings, etc.) this can just be an html template. For now, we create an old school pump
// bank widget in our shadow root and we have to include allll the css in the html file for the pump bank. This is very clunky.

@RegisterWidget({tag: 'tc-pump-bank', displayName: 'Pump Bank', section: 'Pumps', template: template})
export class PumpBank extends Widget {
    wrapper: HTMLDivElement;
    @Attribute({
        displayName: 'Background Color',
        getInput: (name, parent, property, getValue, onSettingChangedCallback, tooltip) => new ColorInput(name, parent, property, getValue, onSettingChangedCallback, tooltip)
    }) backgroundColor: string = '#ffffff';
    @Attribute({
        displayName: 'Text Color',
        getInput: (name, parent, property, getValue, onSettingChangedCallback, tooltip) => new ColorInput(name, parent, property, getValue, onSettingChangedCallback, tooltip)
    }) textColor: string = '#1D1B20';
    @TagAttribute({displayName: 'Pump Folder'}) pumpsFolder: TagDefinition;
    @TagAttribute({displayName: 'DPO Folder', isOptional: true}) dpoFolder: TagDefinition;

    protected connectedCallback(): void {
        this.wrapper = this.shadowRoot?.getElementById('wrapper') as HTMLDivElement;
    }

    protected enliven(): void {
        let slot = document.createElement('slot');
        this.shadowRoot?.append(slot);
        let pumpBank = new PumpBankWidget(this.pumpsFolder.tag, this.wrapper, this.dpoFolder?.tag);
    }
}